export const ERRORS = {
  empty: 'ERRORS.EMPTY',
  email: 'ERRORS.INVALID_EMAIL',
  phoneNumber: 'ERRORS.INVALID_PHONE',
  invalidFiscalCode: 'ERRORS.INVALID_FISCALCODE',
  invalidField: 'ERRORS.INVALID_FIELD',
  invalidNumber: 'ERRORS.INVALID_NUMBER',
  invalidBatchValue: 'ERRORS.INVALID_BATCHVALUE',
  invalidCoupon: 'ERRORS.INVALID_COUPON',
  invalidFileSize: 'ERRORS.INVALID_FILE_SIZE',
  invalidFileType: 'ERRORS.INVALID_FILE_TYPE',
};
